import type { Space } from '@cocoonspace/sdk-js/types/space'
import mitt from 'mitt'

export type MapEvents = {
	'map.resetToZone': undefined
	'map.fitBounds': undefined
	'map.cardOver': Space
	'map.cardOut': undefined
}

export const mapEmitter = mitt<MapEvents>()
